import { useState } from "react"
import { cookie } from "utils/helpers"
import { useMessages } from "../language/language"
import "./cookie-consent.less"

interface Props {}

const COOKIE_NAME = "privacyAgree"

export default function CookieConsent(props: Props) {
  const msg = useMessages()
  const [isAccepted, setIsAccepted] = useState(() => {
    const isPrintPreview = location.href.includes("print-preview")
    if (isPrintPreview) return true

    return cookie.getItem(COOKIE_NAME) !== null
  })

  function handleAccepted() {
    cookie.setItem(COOKIE_NAME, "true")
    setIsAccepted(true)
  }

  const privacyPolicyUrl = `/${msg.locale_code}/privacy-policy`
  const termsAndConditionsUrl = `/${msg.locale_code}/terms-and-conditions`

  if (isAccepted) return null

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-body">
        <p>
          {msg.cookies_message} &nbsp;
          <a href={privacyPolicyUrl} target="_blank">
            {msg.cookies_cookiePolicy}
          </a>{" "}
          &nbsp;
          <a href={termsAndConditionsUrl} target="_blank">
            {msg.cookies_termsOfService}
          </a>
        </p>
        <button className="btn btn-primary btn-action" onClick={handleAccepted}>
          {msg.cookies_agree}
        </button>

        <button className="btn btn-sm btn-text close" onClick={handleAccepted}>
          🗙
        </button>
      </div>
    </div>
  )
}
